import { tasksSlice } from './slice';
export const tasksReducer = tasksSlice.reducer;
export * from './actions';
export * from './store';
